import AuditTrailRoutes from './AuditTrail/routes';
import OptionalModulesRoutes from './OptionalModules/routes';
import PaymentProcessingRoutes from './PaymentProcessing/routes';
import RegisterRulesRoutes from './RegisterRules/routes';
import OmniLocationsRoutes from './OmniLocations/routes';
import TippingRoutes from './Tipping/routes';

export default [
  ...AuditTrailRoutes,
  ...OptionalModulesRoutes,
  ...PaymentProcessingRoutes,
  ...RegisterRulesRoutes,
  ...OmniLocationsRoutes,
  ...TippingRoutes,
];
